module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/contatos/leads",
      "title": "Ir para página inicial"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo.png"),
      "width": "106",
      "alt": "Reev"
    }
  })]), _vm._m(0)], 1), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [(!_vm.current_user.requireEmailAuthorization()) ? [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('router-link', {
    staticClass: "menu-item icon-tasks",
    attrs: {
      "to": "/tarefas"
    }
  }, [_vm._v("Tarefas")])], 1), _c('li', [_c('router-link', {
    staticClass: "menu-item icon-flows",
    attrs: {
      "to": "/fluxos-de-cadencia"
    }
  }, [_vm._v("Fluxos")])], 1), _c('li', [_c('router-link', {
    staticClass: "menu-item icon-templates",
    attrs: {
      "to": "/templates"
    }
  }, [_vm._v("Templates")])], 1), _c('li', [_c('router-link', {
    staticClass: "menu-item icon-contacts",
    attrs: {
      "to": "/contatos/leads"
    }
  }, [_vm._v("Contatos")])], 1)])] : _vm._e(), _c('div', {
    staticClass: "pull-right alert-buttons"
  }, [(!_vm.current_user.isAdmin()) ? _c('email') : _vm._e(), (!_vm.current_user.isAdmin()) ? _c('voip') : _vm._e(), _c('notification-bell'), _c('div', {
    staticClass: "dropdown user-area",
    attrs: {
      "text": "Action",
      "type": "primary"
    }
  }, [_c('div', {
    staticClass: "user-miniature-wrapper dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('div', {
    staticClass: "user-miniature-picture-wrapper"
  }, [_c('img', {
    staticClass: "user-miniature-picture",
    attrs: {
      "src": _vm.current_user.picture_url
    }
  })]), _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "user-miniature-name"
  }, [_vm._v(_vm._s(_vm.current_user.firstName()))]), _c('br'), _c('div', {
    staticClass: "user-miniature-role overflow-ellipsis"
  }, [_vm._v(" " + _vm._s(_vm.current_user.company.name))])]), _c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })]), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.to_help,
      "target": "_blank"
    }
  }, [_vm._v("Ajuda"), _c('i', {
    staticClass: "icon-help glyphicon glyphicon-question-sign"
  })])]), (_vm.show_change_account) ? _c('li', [_c('a', {
    staticClass: "change-account-hover"
  }, [_vm._v("Alterar Conta"), _c('change-account', {
    on: {
      "update-user": _vm.updateCurrentUser
    }
  })], 1)]) : _vm._e(), _c('li', [_c('router-link', {
    staticClass: "configuration",
    attrs: {
      "to": "/configuracoes/perfil"
    }
  }, [_vm._v("Configurações")])], 1), _c('li', [_c('a', {
    on: {
      "click": _vm.goToNewUi
    }
  }, [_vm._v("Testar a nova versão")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Sair")])])])])], 1)], 2)]), _c('notifications-popup')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5075ee1b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/header.vue
// module id = 1110
// module chunks = 1